/**
 * Die Elemente, die in der App tatsächlich scrollen, von innen nach außen.
 *
 * Reihenfolge ist Absicht, auch wenn CSS sie ignoriert: `closest()` liefert
 * ohnehin den nächstgelegenen Treffer. Sie steht hier als Dokumentation der
 * Schachtelung — je weiter hinten, desto weiter außen.
 *
 * - `.project-page__body-main` — die Aufgabenliste der Projektseite und von
 *   **Kurz notiert** (dort seit #273; davor rollte die Spalte selbst). Scrollt
 *   seit ADR 0006 selbst, damit die Bildlaufleiste an IHRER Kante sitzt und
 *   nicht ganz rechts über dem Canvas.
 * - `.done-page__scroll` — die Seite **Geschafft**; scrollt selbst wie die
 *   Projektseite, damit die Zeile beim Auswählen ins Bild kommt.
 * - `.tab-stack__slot-scroll` — der Scroller pro Tab. Seit dem TabStack-Umbau
 *   der Normalfall; er hält `scrollTop` inaktiver Tabs, weil das Element
 *   montiert bleibt.
 * - `.main-layout__scroll-wrap` — der frühere gemeinsame Scroller. Er scrollt
 *   NICHT mehr (`MainLayout.tsx` sagt es selbst), bleibt aber in der Liste:
 *   Seiten außerhalb des TabStack — das eigenständige Einstellungsfenster,
 *   Storybook — haben keinen Slot.
 */
const SCROLL_CONTAINER_SELECTOR =
  '.project-page__body-main, .done-page__scroll, .tab-stack__slot-scroll, .main-layout__scroll-wrap'

/**
 * Der Scroll-Container über einem Element.
 *
 * Bis hierher stand dieselbe Auswahl-Zeichenkette an dreizehn Stellen kopiert
 * im Code. Das war nicht bloß unschön: Zwei Aufrufer trugen eine ältere
 * Fassung, die nur `.main-layout__scroll-wrap` kannte — und weil der seit dem
 * TabStack-Umbau nicht mehr scrollt, waren beide wirkungslos, ohne dass es
 * jemandem auffiel.
 *
 * Neue Scroller gehören deshalb in `SCROLL_CONTAINER_SELECTOR`, nicht in einen
 * weiteren `closest()`-Aufruf.
 *
 * @param el Ausgangspunkt. `null`/`undefined` ist erlaubt, damit Aufrufer
 *   `ref.current` direkt durchreichen können.
 * @returns Der nächstgelegene Scroll-Container oder `null`.
 */
export function getScrollContainer(el: Element | null | undefined): HTMLElement | null {
  return el?.closest<HTMLElement>(SCROLL_CONTAINER_SELECTOR) ?? null
}
